import { openBlock as r, createElementBlock as n, createTextVNode as t, createElementVNode as c, toDisplayString as s } from "vue";
import { _ as d } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const p = {
  compatConfig: { MODE: 3 },
  name: "DtCodeblock",
  props: {
    text: {
      type: String,
      required: !0
    }
  }
}, l = { class: "d-codeblock" };
function i(a, e, o, m, f, u) {
  return r(), n("pre", null, [
    e[0] || (e[0] = t("    ", -1)),
    c("code", l, s(o.text), 1),
    e[1] || (e[1] = t(`
  `, -1))
  ]);
}
const k = /* @__PURE__ */ d(p, [["render", i]]);
export {
  k as default
};
//# sourceMappingURL=codeblock.js.map
